import { useState, useEffect } from 'react';
import { decorationRepository } from '../../../domain/decorationsRepository';


export const useDecorations = (typeId, page) => {
    const [decorationsResult, setDecorationsResult] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [isNextPageLoading, setIsNextPageLoading] = useState(false);

    useEffect(() => {
        console.log(`trigger useDecorations typeId: ${typeId}`)
        console.log(`trigger useDecorations page: ${page}`)
        setIsNextPageLoading(page !== 0)
        console.log(`trigger useDecorations page !== 0: ${page !== 0}`)
        decorationRepository.getDecorations(typeId, page)
        .then((result) => {
            setDecorationsResult(result)
            setIsLoading(false)
            setIsNextPageLoading(false)
        })
        .catch((err) => {
            console.error("Failed to fetch decoration types:", err)
            setIsLoading(false)
            setIsNextPageLoading(false)
        });
    }, [typeId, page]);

    return { ...decorationsResult, isLoading, isNextPageLoading };
};